import { RocketTwoTone } from '@ant-design/icons';
import { Alert, Space, Card } from 'antd';
import React from 'react';

function Alerts() {
  return (
    <Card title="Alerts">
      <Space>
        <Alert message="Success Text" type="success" showIcon />
        <Alert message="Info Text" type="info" showIcon/>
        <Alert message="Warning Text" type="warning" showIcon/>
        <Alert message="Error Text" type="error" showIcon/>
        <Alert message="Custom Icon" type="info" showIcon icon={<RocketTwoTone />} />
      </Space>
    </Card>
  )
}


export default Alerts;
